module.exports = __webpack_public_path__ + "media/Flugridity_01.e3c3a6b5.mp4";